import React, { useState, useEffect } from 'react';

import { useFormik } from 'formik';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {withTranslation} from 'react-i18next';

import {isMobileAndTablet, isMobileApp} from '../../helpers/common';
import {hideLoading, showLoading} from '../../redux/actions/loadingActions';
import logo from '../../assets/img/member-registration/BreadCafe_Logo.jpg';
import IPosModal from '../../IPosModal';
import iposApi from '../../api/iposApi';

import './MemberBreadcafePage.scss';

const validate = (values) => {
    const errors = {};
    if (!values.firstName) {
        errors.firstName = 'שדה חובה';
    }

    if (!values.lastName) {
        errors.lastName = 'שדה חובה';
    }

    if (!values.email) {
        errors.email = 'שדה חובה';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        errors.email = 'כתובת אימייל לא חוקית';
    }

    if (!values.mobile) {
        errors.mobile = 'שדה חובה';
    } else if (!/^[0-9]{10}$/i.test(values.mobile)) {
        errors.mobile = 'נייד צריך להיות בן 10 ספרות בלבד';
    }

    return errors;
};

const MemberBreadcafePage = ({ t, showLoading, hideLoading }) => {
    // const { register, handleSubmit, watch,  formState: { errors }, clearErrors } = useForm({
    //     criteriaMode: 'all'
    // });
    const isMobile = isMobileAndTablet();

    const formik = useFormik({
        initialValues: {
            firstName: '',
            lastName: '',
            mobile: '',
            email: '',
        },
        validate,
        onSubmit: (values) => {
            console.log(values);
            sendEmail(values.firstName, values.lastName, values.mobile, values.email);
        },
    });

    const sendEmail = (firstName, lastName, mobile, email) => {
        const url = '/SendMail';

        const data = [
            {
                'label': 'שם פרטי',
                'value': firstName
            },
            {
                'label': 'שם משפחה',
                'value': lastName
            },
            {
                'label': 'נייד',
                'value': mobile
            },
            {
                'label': 'מייל',
                'value': email
            }
        ];

        console.log('Sending email', data);

        showLoading();

        iposApi.post(url, data).then((res) => {
            if (res.data.Successful){
                IPosModal.alert({
                    title: '',
                    message: 'ההרשמה בוצעה בהצלחה',
                    okButtonText: t('buttons.ok'),
                    onOk: () => {
                        formik.resetForm();
                        hideLoading();
                    }
                });
            } else {
                IPosModal.alert({
                    title: '',
                    message: 'לקוח עם מספר טלפון זהה כבר נמצא במערכת',
                    okButtonText: t('buttons.ok'),
                    onOk: () => {
                        hideLoading();
                    }
                });
            }
        } );
    };

      useEffect(() => {
        setTimeout(() => {
          hideLoading();
        });
      }, []);

      return (
        <div className={ 'member-breadcafe-page' } >
            <div className={ 'content' }>
                <div className={ 'title' }>רישום למועדון לקוחות</div>
                <div className={ 'logo-block' }>
                    <img src={ logo } alt={ '' } />
                </div>
                <div className={ 'form-block' }>
                    <form className={ 'card-form' } onSubmit={ formik.handleSubmit }>
                        <div className={ 'form-input ' }>
                            <input
                                type="text"
                                name="firstName"
                                onChange={ formik.handleChange }
                                value={ formik.values.firstName }
                                placeholder={ 'שם פרטי' }
                            />
                            {formik.errors.firstName && <div className={ 'error' }>{formik.errors.firstName}</div>}
                        </div>
                        <div className={ 'form-input ' }>
                            <input
                                type="text"
                                name="lastName"
                                onChange={ formik.handleChange }
                                value={ formik.values.lastName }
                                placeholder={ 'שם משפחה' }
                            />
                            {formik.errors.lastName && <div className={ 'error' }>{formik.errors.lastName}</div>}
                        </div>
                        <div className={ 'form-input ' }>
                            <input
                                type="tel"
                                name="mobile"
                                maxLength={ 10 }
                                onChange={ formik.handleChange }
                                value={ formik.values.mobile }
                                placeholder={ 'נייד' }
                            />
                            {formik.errors.mobile && <div className={ 'error' }>{formik.errors.mobile}</div>}
                        </div>
                        <div className={ 'form-input ' }>
                            <input
                                type="email"
                                name="email"
                                onChange={ formik.handleChange }
                                value={ formik.values.email }
                                placeholder={ 'מייל' }
                            />
                            {formik.errors.email && <div className={ 'error' }>{formik.errors.email}</div>}
                        </div>
                        <div className={ 'submit-block' }>
                            <button type="submit" className={ 'submit-button' }>הרשם</button>
                        </div>
                    </form>
                </div>

            </div>
            <div className={ 'footer' }>
                powered by iPOS
            </div>

        </div>
      );
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            showLoading, hideLoading,
        },
        dispatch,
    );

export default withTranslation()(connect(null, mapDispatchToProps)(MemberBreadcafePage));
